import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import React from 'react';

type ModalShowErrorProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: number;
};

const ModalShowError = ({
  isOpen,
  onClose,
  maxWidth,
  children,
}: ModalShowErrorProps) => {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay background="#000000b3" />
      <ModalContent maxW={maxWidth ? maxWidth : 320} rounded={20}>
        <ModalBody p={'32px 24px'}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalShowError;
